import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ContextMenuLabelProps } from "../../../../contextmenu/ContextMenuLabelProps";
import { OpenType } from "../../../../../page/openButtons/OpenType";

export class DetailDropdownButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonDetailDropdown`,
            enabled: false,
            imageName: ImageName.arrow,
            imageWidth: 12,
            imageHeight: 12,
            padding: 8,
            borderWidth: 0,
            margin: 0,
            paddingLeft: 0,
            marginLeft: 0,
            paddingRight: 2,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            contextMenuItems: () => this.getDetailDropdownItems(),
            tooltip: "Show other options for drilling down to the selected row in this table"
        });
    }

    override rowSelectionChanged() {
        this.button.enabled = this.table.selectedRowCount === 1;
    }

    private getDetailDropdownItems(): Partial<ContextMenuLabelProps>[] {
        const result: Partial<ContextMenuLabelProps>[] = [];
        this.addDetailDropdownItem(result, OpenType.SAME_TAB, "Open");
        this.addDetailDropdownItem(result, OpenType.NEW_TAB_WITH_SWITCH, "Open in New Tab");
        this.addDetailDropdownItem(result, OpenType.NEW_WINDOW, "Open in New Window");
        return result;
    }

    private addDetailDropdownItem(array: Partial<ContextMenuLabelProps>[], openType: OpenType, text: string) {
        const defaultOpenType = this.table.crudManager.defaultOpenType;
        if (openType != defaultOpenType) {
            const contextMenuLabelProps: Partial<ContextMenuLabelProps> = {
                text,
                onClick: () => {
                    this.table.crudManager.defaultOpenType = openType;
                    this.table.crudManager.showDetail(openType);
                }
            };
            array.push(contextMenuLabelProps);
        }
    }
}
